import { render, staticRenderFns } from "./CurrentSubscriptionButtons.vue?vue&type=template&id=872c10b4"
import script from "./CurrentSubscriptionButtons.vue?vue&type=script&lang=js"
export * from "./CurrentSubscriptionButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('872c10b4')) {
      api.createRecord('872c10b4', component.options)
    } else {
      api.reload('872c10b4', component.options)
    }
    module.hot.accept("./CurrentSubscriptionButtons.vue?vue&type=template&id=872c10b4", function () {
      api.rerender('872c10b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Billing/Components/CurrentSubscriptionButtons.vue"
export default component.exports